// Athletes Service - Handles fetching athletes data for display
import { supabase } from '../lib/supabase'
import { createClient } from '@supabase/supabase-js'

class AthletesService {
  // Get all athletes with their school and sport information
  async getAthletes() {
    try {
      // Use service role client to bypass RLS for public viewing
      const serviceRoleClient = createClient(
        supabase.supabaseUrl,
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5peWl6eWt2bWlyY3V1enptdGFmIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc3NjI3NTg1MCwiZXhwIjoyMDkxODUxODUwfQ.2s1Esbx65iUJP3kxS027YJ_SO6ABph_8SRUn1vIVlNg'
      )

      const { data, error } = await serviceRoleClient
        .from('athletes')
        .select(`
          *,
          schools:school_id (
            name,
            city,
            state
          ),
          sports:sport_id (
            name,
            category
          )
        `)
        .order('created_at', { ascending: false })

      if (error) throw error
      console.log('Fetched athletes:', data?.length || 0)
      return data
    } catch (error) {
      console.error('Error fetching athletes:', error)
      throw error
    }
  }

  // Get single athlete with all their details including media
  async getAthleteById(athleteId) {
    try {
      // Use service role client to bypass RLS for public viewing
      const serviceRoleClient = createClient(
        supabase.supabaseUrl,
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5peWl6eWt2bWlyY3V1enptdGFmIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc3NjI3NTg1MCwiZXhwIjoyMDkxODUxODUwfQ.2s1Esbx65iUJP3kxS027YJ_SO6ABph_8SRUn1vIVlNg'
      )

      // Get athlete basic info
      const { data: athlete, error: athleteError } = await serviceRoleClient
        .from('athletes')
        .select(`
          *,
          schools:school_id (
            name,
            city,
            state
          ),
          sports:sport_id (
            name,
            category
          )
        `)
        .eq('id', athleteId)
        .single()

      if (athleteError) throw athleteError

      // Get athlete media files
      const { data: media, error: mediaError } = await serviceRoleClient
        .from('athlete_media')
        .select('*')
        .eq('athlete_id', athleteId)
        .order('created_at', { ascending: false })

      if (mediaError) throw mediaError

      // Get athlete social media
      const { data: socialMedia, error: socialError } = await serviceRoleClient
        .from('athlete_social_media')
        .select('*')
        .eq('athlete_id', athleteId)

      if (socialError) throw socialError

      // Get athlete achievements
      const { data: achievements, error: achievementsError } = await serviceRoleClient
        .from('athlete_achievements')
        .select('*')
        .eq('athlete_id', athleteId)
        .order('date_achieved', { ascending: false })

      if (achievementsError) throw achievementsError

      // Get public URLs for media files
      const mediaWithUrls = await Promise.all(
        media.map(async (file) => {
          const { data: urlData } = await serviceRoleClient.storage
            .from('athlete-media')
            .getPublicUrl(file.file_path)
          
          return {
            ...file,
            publicUrl: urlData.publicUrl
          }
        })
      )

      return {
        athlete,
        media: mediaWithUrls,
        socialMedia,
        achievements
      }
    } catch (error) {
      console.error('Error fetching athlete details:', error)
      throw error
    }
  }

  // Get public URL for media file
  async getMediaUrl(filePath) {
    try {
      const { data } = supabase.storage
        .from('athlete-media')
        .getPublicUrl(filePath)
      
      return data.publicUrl
    } catch (error) {
      console.error('Error getting media URL:', error)
      return null
    }
  }
}

export default new AthletesService()
